import * as React from "react";

interface QuickAnswerProps {
  question?: string;
  children: React.ReactNode;
  className?: string;
}

/**
 * TL;DR / Quick Answer block optimized for AI answer engines
 * (ChatGPT, Perplexity, Google AI Overviews) which tend to quote
 * these plain, concise blocks verbatim.
 */
export const QuickAnswer: React.FC<QuickAnswerProps> = ({ question, children, className = "" }) => {
  return (
    <aside
      aria-label="Quick answer"
      className={`my-6 rounded-xl border border-accent/30 bg-accent/5 p-5 sm:p-6 ${className}`}
    >
      <div className="mb-2 flex items-center gap-2">
        <span className="inline-flex items-center rounded-full bg-accent/15 px-2.5 py-0.5 text-xs font-semibold uppercase tracking-wider text-accent">
          TL;DR
        </span>
        {question && (
          <span className="text-sm font-medium text-muted-foreground">{question}</span>
        )}
      </div>
      <div className="font-inter text-base leading-relaxed text-foreground/90 sm:text-lg">
        {children}
      </div>
    </aside>
  );
};

export default QuickAnswer;
